<nav
    class="navbar fixed-bottom navbar-dark flex-column"
    aria-hidden="true"
    #n
>
    <ul class="navbar-nav flex-row">
        <li>
            <a
                class="nav-link mr-2"
                href
                (click)="onMoveClick(n, true); (false)"
                ><strong>L</strong></a
            >
        </li>
        <li style="flex-grow: 1">
            <a
                class="nav-link text-center"
                href
                (click)="isCollapsed = !isCollapsed; (false)"
                ><strong>debug</strong></a
            >
        </li>
        <li>
            <a
                class="nav-link ml-2"
                href
                (click)="onMoveClick(n, false); (false)"
                ><strong>R</strong></a
            >
        </li>
    </ul>
    <div [class.cmps-cdk-d-none]="isCollapsed">
        <ul class="navbar-nav">
            <li>
                <a
                    class="nav-link pt-1 pb-1"
                    href
                    (click)="onInvokeReAuthClick(); (false)"
                    >invoke re-auth</a
                >
            </li>
            <li>
                <a
                    class="nav-link pt-1 pb-1"
                    href
                    (click)="onInvokeTimeoutClick(); (false)"
                    >invoke timeout</a
                >
            </li>
            <li>
                <a
                    class="nav-link pt-1 pb-1"
                    href
                    (click)="onInvokeAuthLostClick(); (false)"
                    >invoke auth lost</a
                >
            </li>
            <li>
                <a
                    class="nav-link pt-1 pb-1"
                    href
                    (click)="onToggleSsoSimulationClick(); (false)"
                    >toggle sso simulation ({{
                        !hasSaml2AuthMethod ? 'off' : 'on'
                    }})</a
                >
            </li>
            <li>
                <a
                    class="nav-link pt-1 pb-1"
                    href
                    (click)="onDismissAllModalsClick(); (false)"
                    >dismiss all modals</a
                >
            </li>
            <li>
                <a
                    class="nav-link pt-1 pb-1"
                    href
                    (click)="onAddPiTabClick(); (false)"
                    >add pi tab</a
                >
            </li>
            <li>
                <a
                    class="nav-link pt-1 pb-1"
                    href
                    (click)="_pollNotifications($event)"
                    >poll notifications</a
                >
            </li>
            <li>
                <a
                    class="nav-link pt-1 pb-1"
                    href
                    (click)="_onCoachingSummaryForAllFlowsClick($event)"
                    >coaching summary for all flows</a
                >
            </li>
            <li>
                <a
                    class="nav-link pt-1 pb-1"
                    href
                    (click)="_onCoachingSummaryForAllFlowsClearClick($event)"
                    >clear coaching summary for all flows</a
                >
            </li>
            <li ngbDropdown>
                <a
                    class="nav-link pt-1 pb-1"
                    href
                    (click)="(false)"
                    ngbDropdownToggle
                    >record</a
                >
                <div ngbDropdownMenu>
                    <a
                        class="dropdown-item"
                        href
                        (click)="_onRecordStartClick($event)"
                        >start</a
                    >
                    <a
                        class="dropdown-item"
                        href
                        (click)="_onRecordStopClick($event)"
                        >stop</a
                    >
                    <a
                        class="dropdown-item"
                        href
                        (click)="_onRecordServeClick($event)"
                        >download</a
                    >
                    <a
                        class="dropdown-item"
                        href
                        (click)="_onRecordClearClick($event)"
                        >reset</a
                    >
                </div>
            </li>
            <li ngbDropdown>
                <a
                    class="nav-link pt-1 pb-1"
                    href
                    (click)="(false)"
                    ngbDropdownToggle
                    >nav</a
                >
                <div ngbDropdownMenu>
                    <a
                        class="dropdown-item"
                        [routerLink]="i.commands"
                        [queryParams]="i.queryParams"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{
                            paths: 'exact',
                            queryParams: 'exact',
                            fragment: 'ignored',
                            matrixParams: 'ignored'
                        }"
                        *ngFor="let i of nav"
                        >{{ i.name }}</a
                    >
                </div>
            </li>
            <li>
                <a class="nav-link pt-1 pb-1 text-center">{{ build }}</a>
            </li>
        </ul>
    </div>
</nav>
